import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";

const state = {
    userData: null,
};

const getters = {
    getUserData: state => state.userData,
};

const actions = {
    async fetchUserData({ commit }) {
        
        try {
            const response = await apolloClient.query({
                query: gql`
                    query getUserInfo {
                        getUserInfo {
                            client
                            userId
                            originalUserId
                            userName
                            lastUpdateTimestamp
                            language
                            userMail
                            userPhone
                            purchasingIds
                            isAdmin
                            isMarketing
                            isSuperAdmin
                        }
                    }
                `
            });


            
            commit('setUserData', response.data.getUserInfo);
        } catch (error) {
            console.error('Error while fetching user data:', error);
        }
    },
    async init({commit}) {
        
        await this.dispatch('user/fetchUserData');
    },
};

const mutations = {
    setUserData(state, userData) {
        state.userData = userData;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
